import { AxiosInstance } from "./AxiosInstance"

export const SWRConfigOptions = {
    fetcher: (url: string) => { AxiosInstance.get(url).then((res) => res.data) },
    refreshInterval: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    shouldRetryOnError: false,
    errorRetryCount: 0,
}